import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './PageProgress.scss';

class PageProgress extends Component {
    render() {
        const { pageNumber, currentPageNumber, title } = this.props;
        return (
            <div className='fl-sv-page-progress'>
                <span className='fl-sv-page-pg-text'>
                    { title ? `${ title } ` : '' }{ currentPageNumber }/{ pageNumber }
                </span>
            </div>
        );
    }
}

PageProgress.propTypes = {
    currentPageNumber: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    title: PropTypes.string
};

PageProgress.defaultProps = {
    title: ''
};

export default PageProgress;
